import { GroupState, SideBarList } from '@/composition/groups'
import {
  DocumentsAndPayments,
  NotificationMobileView,
  ProfileContainer,
} from '@ghl/clientportal-core'
import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'

import ErrorComponent from '@/components/common/Error.vue'
import { MorePage } from '@ghl/clientportal-core'
import GlobalUserProfile from '../pages/GlobalUserProfile.vue'
import GroupContainer from '../pages/GroupContainer.vue'
import Groups from '../pages/GroupsPage.vue'
import MainContainer from '../pages/MainContainer.vue'
// import from clientportal-core
import PostViewRouter from '@/components/posts/postview/PostViewRouter.vue'
import { app } from '@/composition/app'
import { resetGroupData } from '@/helper/groups.helper'
import { isGokollab } from '@ghl/clientportal-core/init'
import { defineAsyncComponent } from 'vue'
import { requireAuth } from './guards'
import { RouterHelper } from './router.helper'

// import from clientportal-core
// import from clientportal-core

const ChatViewIndex = defineAsyncComponent({
  loader: () => import('@/components/chats/ChatViewIndex.vue'),
  errorComponent: ErrorComponent,
})

const ConversationsMobile = defineAsyncComponent({
  loader: () => import('@/components/chats/mobile/ConversationsMobile.vue'),
  errorComponent: ErrorComponent,
})

// const MorePage = defineAsyncComponent({
//   loader: () => import('@ghl/clientportal-core'),
//   errorComponent: ErrorComponent,
// })

const GroupSettings = defineAsyncComponent({
  loader: () => import('@/components/groups/settings/GroupSettings.vue'),
  errorComponent: ErrorComponent,
})

const Learning = defineAsyncComponent({
  loader: () => import('@/pages/LearningPage.vue'),
  errorComponent: ErrorComponent,
})

const GroupMembers = defineAsyncComponent({
  loader: () => import('../components/groups/groupMembers/GroupMembers.vue'),
  errorComponent: ErrorComponent,
})

const CommunitySettings = defineAsyncComponent({
  loader: () => import('../components/reports/CommunitySettings.vue'),
  errorComponent: ErrorComponent,
})
const ContentReports = defineAsyncComponent({
  loader: () => import('../components/reports/ContentReports.vue'),
  errorComponent: ErrorComponent,
})
const CommunitiesHome = defineAsyncComponent({
  loader: () => import('../pages/CommunitiesHome.vue'),
  errorComponent: ErrorComponent,
})
const routes: Readonly<RouteRecordRaw[]> = [
  {
    path:
      import.meta.env.VITE_JS_IS_GOKOLLAB == 'true'
        ? '/:groupSlug'
        : '/communities/groups/:groupSlug',
    component: GroupContainer,
    meta: {
      priority: 'high',
    },
    name: 'communities',
    children: [
      {
        name: 'home',
        path: 'home',
        meta: {
          priority: 'high',
        },
        component: Groups,
        children: [
          {
            name: 'group-post-view',
            path: 'posts/:postId',
            component: PostViewRouter,
            props: true,
          },
        ],
      },
      {
        path: 'search',
        name: 'group-home-search',
        component: () => import('../pages/SearchView.vue'),
        props: true,
        children: [
          {
            name: 'group-search-post-view',
            path: 'posts/:postId',
            component: PostViewRouter,
            props: true,
          },
        ],
      },

      {
        path: 'content-unavailable',
        name: 'content-unavailable',
        component: () => import('@/pages/ContentUnavailable.vue'),
      },
      {
        path: 'clientportal-home',
        name: 'clientportal-home',
        component: CommunitiesHome,
        beforeEnter: requireAuth,
      },
      {
        path: 'profile',
        name: 'profile-container',
        component: ProfileContainer,
        beforeEnter: requireAuth,
      },
      {
        path: 'documents-and-payments',
        name: 'documents-and-payments',
        component: DocumentsAndPayments,
        beforeEnter: (_to, from, next) => {
          if (app.state.isMobile && isGokollab()) {
            next()
          } else {
            next(from)
          }
        },
      },
      {
        name: 'no-communities-mobile',
        path: 'no-communities',
        component: () => import('@/pages/NoCommunities.vue'),
      },

      {
        name: 'channel-overview',
        path: 'channels/:channelSlug',
        component: () => import('../pages/ChannelsPage.vue'),
        children: [
          {
            name: 'channel-post-view',
            path: 'posts/:postId',
            component: PostViewRouter,
            props: true,
          },
        ],
      },
      {
        path: 'channels/:channelSlug/search',
        name: 'channel-search',
        component: () => import('../pages/SearchView.vue'),
        props: true,
        children: [
          {
            name: 'channel-search-post-view',
            path: 'posts/:postId',
            component: PostViewRouter,
            props: true,
          },
        ],
      },

      {
        name: 'group-member-list',
        path: 'member-list',
        component: GroupMembers,
      },
      {
        // This routes to contents reports page for mobile and group settings with Reported Content tab selected for web
        name: 'to-review',
        path: 'to-review',
        component: app.state.isMobile ? ContentReports : GroupSettings,
        props: { show: true },
      },
      {
        // This routes to group settings page
        name: 'settings/details',
        path: 'settings/details',
        component: GroupSettings,
        props: { show: true },
      },
      {
        // this route is only for mobile
        name: 'communities-settings',
        path: 'communities-settings',
        component: CommunitySettings,
        beforeEnter: (_to, from, next) => {
          if (app.state.isMobile) {
            next()
          } else {
            next(from)
          }
        },
      },
      {
        // this route is only for mobile
        name: 'communities-more',
        path: 'communities-more',
        component: MorePage,
        beforeEnter: (_to, from, next) => {
          if (app.state.isMobile) {
            next()
          } else {
            next(from)
          }
        },
      },

      {
        // this route is only for mobile
        name: 'conversations',
        path: 'conversations',
        component: ConversationsMobile,

        beforeEnter: (_to, from, next) => {
          if (app.state.isMobile) {
            next()
          } else {
            next(from)
          }
        },
      },
      {
        // this route is only for mobile
        name: 'chat-view',
        path: 'conversations/:conversationId',
        component: ChatViewIndex,
        props: true,
        beforeEnter: (_to, from, next) => {
          if (app.state.isMobile) {
            next()
          } else {
            next(from)
          }
        },
      },
      {
        name: 'user-profile',
        path: 'users/:userSlug',
        component: () => import('@/pages/UserProfile.vue'),
        children: [
          {
            name: 'user-post-view',
            path: 'posts/:postId',
            component: PostViewRouter,
            props: true,
          },
        ],
      },
      {
        name: 'learning-home',
        path: 'learning',
        component: Learning,
      },
      {
        // need to keep name in this format,it's required for red dot in common bottombar
        name: 'NotificationMobileView',
        path: 'notification-mobile',
        component: NotificationMobileView,
        beforeEnter: (_to, from, next) => {
          if (app.state.isMobile) {
            next()
          } else {
            next(from)
          }
        },
      },
      {
        name: 'events',
        path: 'events',
        component: () => import('@/pages/CalendarPage.vue'),
      },
      {
        name: 'leaderboard',
        path: 'leaderboard',
        component: () => import('@/pages/LeaderboardPage.vue'),
      },
      {
        name: 'about',
        path: 'about',
        component: () => import('@/pages/AboutPage.vue'),
      },
      {
        // this route is only for mobile
        name: 'my-courses',
        path: 'my-courses',
        component: () => import('@/pages/MyCourses.vue'),
        beforeEnter: (_to, from, next) => {
          if (app.state.isMobile) {
            next()
          } else {
            next(from)
          }
        },
      },

      {
        name: 'inactive-group',
        path: 'inactive-group',
        component: () => import('@/pages/InactiveGroup.vue'),
      },
      {
        name: 'private-group',
        path: 'private-group',
        component: () => import('@/pages/PrivateGroup.vue'),
      },
    ],
  },
  {
    path: '/',
    component: MainContainer,
    children: [
      {
        path:
          import.meta.env.VITE_JS_IS_GOKOLLAB == 'true'
            ? '/users/:userSlug'
            : '/communities/users/:userSlug',
        name: 'global-user-profile',
        component: GlobalUserProfile,
        props: true,
        children: [
          {
            name: 'global-user-profile-post-view',
            path: 'posts/:postId',
            component: PostViewRouter,
            props: true,
          },
        ],
      },
    ],
  },
  {
    path: '/404',
    name: 'not-found',
    component: () => import('@/pages/NotFound.vue'),
  },
  {
    name: 'no-communities',
    path: '/communities/no-communities',
    component: () => import('@/pages/NoCommunities.vue'),
  },
  {
    path: '/:catchAll(.*)',
    name: 'communities-base',
    component: () => import('../pages/GroupContainer.vue'),
  },
]

const postViewPages = {
  'group-post-view': true,
  'group-post-full-view': true,
  'user-post-view': true,
  'channel-post-view': true,
  'group-home-search': true,
  'channel-search': true,
  'global-user-profile-post-view': true,
  'global-user-profile': true,
}
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from) {
    if (
      (to?.name && to.name in postViewPages) ||
      (from?.name && from.name in postViewPages)
    ) {
      return
    }
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach(async (to, from) => {
  if (isGokollab() && to?.query?.am_id) {
    const groupSlug = to?.params?.groupSlug as string
    const amId = to?.query?.am_id as string
    const storageString = groupSlug
      ? `${groupSlug}-affiliateManagerId`
      : 'affiliateManagerId'
    localStorage.setItem(storageString, amId)
  }
  // Decide modal vs full-page for post routes based on navigation origin
  const postRouteNames: Record<string, boolean> = {
    'group-post-view': true,
    'channel-post-view': true,
    'user-post-view': true,
    'group-search-post-view': true,
    'channel-search-post-view': true,
    'global-user-profile-post-view': true,
  }

  if (to.name && postRouteNames[String(to.name)]) {
    // If coming from inside the app, open as modal; otherwise, full-page
    // Note: mobile handling remains in PostViewRouter.vue
    to.meta.openAsModal = !!from.name
  }
  if (to.name === 'private-group' || to.name === 'inactive-group') {
    GroupState.state.sideBarListView = SideBarList.GROUPS
    GroupState.state.closedGroup = true
  } else {
    GroupState.state.sideBarListView = SideBarList.CHANNELS
    GroupState.state.closedGroup = false
  }

  // Check if we're switching to a different group or initial navigation to a group
  if (to.params?.groupSlug) {
    const isGroupSwitch =
      from.params?.groupSlug && to.params.groupSlug !== from.params.groupSlug
    const isInitialGroupNavigation = !from.params?.groupSlug

    if (isGroupSwitch || isInitialGroupNavigation) {
      // Reset group data and set loading flag when switching groups or initial navigation
      resetGroupData()
    }
  }

  Promise.all([
    RouterHelper.handleBannedUser(to, router),
    RouterHelper.handlePrivateGroups(to, router, from),
    RouterHelper.handleInactiveGroups(to, router),
    RouterHelper.sendPendoTrackingEvent(to),
  ])
})

// router.js
router.afterEach(to => {
  RouterHelper.checkAndShowMandatoryInfoModel(to)
})
export { router }
